<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesQualityProjectResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      with-custom-row-actions-first-column
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button
                                            type="gotoChild"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="查看检验详情"
                                            @click="gotoChildPage(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Liang Gang Qiang
// Date 2021-10-13 14:43:42

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";

export default {
    name: "mintalMesQualityProjectListView",
    mixins: [emCommonListMixin, emCommonGotoMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        gotoChildPage(row) {
            this.$_emGotoMixin_gotoHolderList("mintalMesQualityProjectItem"
                , {qualityProjectIdFilter: row.id, qualityProjectNameFilter: row.name}
                , {qualityProjectId: row.id, qualityProjectName: row.name}, false, {});
        },
    }
};
</script>